export default __webpack_public_path__ + "static/media/logo_rhex.7853de69.png";